import { render, staticRenderFns } from "./template.vue?vue&type=template&id=2f82b088&scoped=true&"
import script from "./template.vue?vue&type=script&lang=js&"
export * from "./template.vue?vue&type=script&lang=js&"
import style0 from "../../views/index/style.scss?vue&type=style&index=0&id=2f82b088&lang=scss&scoped=true&"
import style1 from "./style.scss?vue&type=style&index=1&id=2f82b088&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f82b088",
  null
  
)

export default component.exports